import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../lib/api';

const SiteSettingsContext = createContext({ settings: null, refresh: () => {} });

export const SiteSettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);

    const refresh = async () => {
        try {
            const { data } = await api.get('/site-settings');
            setSettings(data || {});
        } catch {
            setSettings({});
        }
    };

    useEffect(() => {
        refresh();
    }, []);

    return (
        <SiteSettingsContext.Provider value={{ settings, refresh }}>
            {children}
        </SiteSettingsContext.Provider>
    );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
